// extracted by mini-css-extract-plugin
export default {"header":"eR","discountBanner":"fR","logo":"gR","maincontainer":"hR","videocontainer":"iR","videowelcome":"jR","videowrapper":"kR","videosale":"lR","loadingcontainer":"mR","footer":"nR","footerbutton":"oR","video":"pR","logoname":"qR"};
    if(module.hot) {
      // 1713912566785
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  